import {
  PROJECT_STATUS,
  ACCESS_STATE_TYPE,
  isContinuousOptimizationType,
} from 'src/data/project';
import { useCurrentProject } from './useCurrentProject';

export const useIsProjectReadOnly = () => {
  const currentProject = useCurrentProject();

  return (
    currentProject &&
    (currentProject.status === PROJECT_STATUS.legacy ||
      (currentProject.accessState !== ACCESS_STATE_TYPE.read_write &&
        !isContinuousOptimizationType(currentProject.type)))
  );
};
